import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, withHashLocation } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { provideHttpClient } from '@angular/common/http';

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy , useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideHttpClient(),
//    provideRouter(routes, withHashLocation()) // 👈 Forces the browser to route via # paths
    provideRouter(routes, withPreloading(PreloadAllModules)),
  ],
})
  .catch((err) => {
    console.error("🚀 BOOTSTRAP REJECTION CAUGHT:", err);
    
    // Inject a visual overlay so you can read the crash reason directly on the device screen
    const errorDiv = document.createElement('div');
    errorDiv.style.position = 'fixed';
    errorDiv.style.top = '0';
    errorDiv.style.left = '0';
    errorDiv.style.width = '100%';
    errorDiv.style.height = '100%';
    errorDiv.style.background = 'white';
    errorDiv.style.color = 'red';
    errorDiv.style.padding = '20px';
    errorDiv.style.zIndex = '999999';
    errorDiv.style.overflow = 'scroll';
    errorDiv.innerHTML = `<h3>Angular Bootstrap Error:</h3><pre>${err.stack || err.message || err}</pre>`;
    document.body.appendChild(errorDiv);
  });


/* import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy, withHashLocation } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { provideHttpClient } from '@angular/common/http';
defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

// 👇 WRAP THE BOOTSTRAP: Force it to wait for Capacitor to be ready
const startApp = () => {
  bootstrapApplication(AppComponent, {
    providers: [
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      //provideIonicAngular({ mode: 'ios' }), 
      provideIonicAngular(),
      provideHttpClient(),
      provideRouter(routes, withHashLocation()), 
    ],
  }).catch((err) => {
    console.error('🚀 BOOTSTRAP FAILED:', err);
    
    const errorOverlay = document.createElement('div');
    errorOverlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:white;color:red;padding:20px;z-index:999999;overflow:scroll;';
    errorOverlay.innerHTML = `<h2>Angular Bootstrap Exception:</h2><pre>${err.stack || err.message || err}</pre>`;
    document.body.appendChild(errorOverlay);
  });
};

// If running in Capacitor, wait for the bridge initialization event; otherwise, boot immediately
if ((window as any).Capacitor) {
  document.addEventListener('deviceready', startApp, false);
} else {
  startApp();
}
 */